import React, { Component } from 'react';
import { menuConfig, adminMenuConfig, menuErweitertConfig } from '../config/MenuConfig';

class Sidebar extends Component {
  state = { 
    links: [ ],
    adminLinks: [],
    sonstLinks: []
  }

  validateData(props) {
    // Allgemeine Menüpunkte
    const links = Object.keys(menuConfig)
      .filter(idx => this.canAccess(menuConfig[idx].link.slice(1)))
      .map(idx => {
        const { label = idx, link, icon = '' } = menuConfig[idx];
        return { link, label, icon };
    });

    // Admin-Menüpunkte rein aus adminMenuConfig, nicht aus schemas
    const adminLinks = Object.keys(adminMenuConfig)
      .filter(idx => this.canAccess(adminMenuConfig[idx].link.slice(1)))
      .map(idx => {
        const { label = idx, link, icon = '' } = adminMenuConfig[idx];
        return { link, label, icon };
    });

    const sonstLinks = Object.keys(menuErweitertConfig)
      .filter(idx => this.canAccess(menuErweitertConfig[idx].link.slice(1)))
      .map((idx) => {
        const { label = idx, link, icon = '' } = menuErweitertConfig[idx];
        return {link, label, icon}
      }) 

    this.setState({ links, adminLinks, sonstLinks});

  }

  canAccess(resource){
    // console.log("ccan? ", resource, global.auth.permissions?.[resource]?.view );
    // Admins haben immer Zugriff auf alle Ressourcen
    if (global.isAdmin) {
      return true;
    }
    return global.auth.permissions?.[resource]?.view
  }

  componentDidMount() {
    this.validateData(this.props);
  }
  componentDidUpdate(newProps){
    if(newProps !== this.props){
      this.validateData(newProps)
    }
  }

  createLink(linkObj, idx = 0) {
    const { link, label, icon } = linkObj;
    const active = window.location.hash === link ? "active" : "";
  
    // icon ist entweder ein String (CSS-Klassen) oder ein React-Komponent
    const IconElem = typeof icon === 'string'
      ? <i className={`sii ${icon}`} />
      : React.createElement(icon, { className: 'sii' });
    return (
      <li className={`nav-item ${active}`} key={idx}>
        <a href={link} className="nav-link">
          <span>
            {IconElem}
            <p>{global.capitalize(label.replace('#', ''))}</p>
          </span>
        </a>
      </li>
    );
  }

  render() {
    let adminUl = <>
      <span className="nav-title txt-caps-small-regular mt-5">ADMIN</span>
      <ul id="admin-nav" className="nav nav-pills nav-sidebar flex-column" data-widget="treeview" role="menu" data-accordion="false">
        { this.state.adminLinks.map( (link, idx) => this.createLink(link, idx) ) }
      </ul>
    </>
    ;

    return (

      <aside className="main-sidebar sidebar-no-expand">
        <a href="#dashboard" className="brand-link">
          <img src="dist/img/DIVOKA_Logo.png" alt="DiVoKa Logo" className="brand-image" />
          {/* <span className="brand-text font-weight-light">Vorsorgekartei</span> */}
        </a>
        <div className="sidebar">
          <nav className="mt-2">
            <span className="nav-title txt-caps-small-regular">MENÜ</span>
            <ul id="allg-nav" className="nav nav-pills nav-sidebar flex-column" data-widget="treeview" role="menu" data-accordion="false">
              { this.state.links.map( (link, idx) => this.createLink(link, idx)  )}
            </ul>
            
            { global.isAdmin ? adminUl: "" }

            <ul id="erweitert-nav" className="nav nav-pills nav-sidebar flex-column" data-widget="treeview" role="menu" data-accordion="false">
              { this.state.sonstLinks.map( (link, idx) => this.createLink(link, idx)) }
            </ul>
          </nav>
        </div>
      </aside>
    );
  }
}

export default Sidebar;
